export default __webpack_public_path__ + "static/747-bc2a2beb3dce177c6cdc89cca6b26ecc.gif";